import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "p-the-header-user-navi" }
const _hoisted_2 = { class: "p-the-header-user-navi__list__item" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "p-the-header-user-navi__list__icon" }
const _hoisted_5 = { class: "p-the-header-user-navi__list__item" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "p-the-header-user-navi__list__icon" }
const _hoisted_8 = {
  key: 0,
  class: "p-the-header-user-navi__list__item"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "p-the-header-user-navi__list__icon" }
const _hoisted_11 = { class: "p-the-header__right__notification" }
const _hoisted_12 = { class: "p-the-header-user-navi__list__text" }
const _hoisted_13 = { class: "p-the-header-user-navi__list__item" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "p-the-header-user-navi__list__icon" }
const _hoisted_16 = { class: "p-the-header__right__notification" }
const _hoisted_17 = { class: "p-the-header-user-navi__list__item" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "p-the-header-user-navi__list__icon" }
const _hoisted_20 = { class: "p-the-header-user-navi__list__item" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "p-the-header-user-navi__list__icon" }
const _hoisted_23 = { class: "p-the-header-user-navi__list__item" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "p-the-header-user-navi__list__icon" }
const _hoisted_26 = {
  key: 1,
  class: "p-the-header-user-navi__list__item"
}
const _hoisted_27 = ["href"]
const _hoisted_28 = { class: "p-the-header-user-navi__list__icon" }
const _hoisted_29 = { class: "p-the-header-user-navi__list__item" }
const _hoisted_30 = ["href"]
const _hoisted_31 = { class: "p-the-header-user-navi__list__icon" }
const _hoisted_32 = { class: "p-the-header-user-navi__list__item" }
const _hoisted_33 = ["href"]
const _hoisted_34 = { class: "p-the-header-user-navi__list__icon" }
const _hoisted_35 = { class: "p-the-header-user-navi__list__item" }
const _hoisted_36 = { class: "p-the-header-user-navi__list__icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconHamburger = _resolveComponent("IconHamburger")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconHumanWithOutline = _resolveComponent("IconHumanWithOutline")!
  const _component_IconPointDefault = _resolveComponent("IconPointDefault")!
  const _component_IconThanksMessage = _resolveComponent("IconThanksMessage")!
  const _component_TextLabelNewArrivalCount = _resolveComponent("TextLabelNewArrivalCount")!
  const _component_IconNotification = _resolveComponent("IconNotification")!
  const _component_IconOrderHistory = _resolveComponent("IconOrderHistory")!
  const _component_IconHistoryLog = _resolveComponent("IconHistoryLog")!
  const _component_IconHeart = _resolveComponent("IconHeart")!
  const _component_IconMail = _resolveComponent("IconMail")!
  const _component_IconFaqBalloon = _resolveComponent("IconFaqBalloon")!
  const _component_IconLogout = _resolveComponent("IconLogout")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "p-the-header-user-navi__button",
      onClick: [
        _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
        _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.switchShownState && _ctx.switchShownState(...args)))
      ]
    }, [
      _createVNode(_component_IconBase, {
        width: 24,
        height: 24,
        "view-box": "0 0 24 24",
        "icon-color": "#000000"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconHamburger)
        ]),
        _: 1
      })
    ]),
    (!_ctx.isAdmin)
      ? (_openBlock(), _createBlock(_Transition, {
          key: 0,
          name: "fade"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("ul", {
              class: "p-the-header-user-navi__list c-common-rounded-shadow",
              onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("li", _hoisted_2, [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: _ctx.urls.mypage,
                  class: "p-the-header-user-navi__list__link c-common-rounded-shadow__label"
                }, [
                  _createElementVNode("i", _hoisted_4, [
                    _createVNode(_component_IconBase, {
                      width: 24,
                      height: 24,
                      "view-box": "0 0 24 24"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconHumanWithOutline)
                      ]),
                      _: 1
                    })
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "p-the-header-user-navi__list__text" }, "マイページ", -1))
                ], 8, _hoisted_3)), [
                  [_directive_touch, void 0, "tap"]
                ])
              ]),
              _createElementVNode("li", _hoisted_5, [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: _ctx.urls.pointConfirmation,
                  class: "p-the-header-user-navi__list__link c-common-rounded-shadow__label"
                }, [
                  _createElementVNode("i", _hoisted_7, [
                    _createVNode(_component_IconBase, {
                      width: 24,
                      height: 24,
                      "view-box": "0 0 24 24"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconPointDefault, {
                          "icon-color": '#ffff',
                          "border-color": '#3c3c3c',
                          "bg-color": '#3c3c3c'
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "p-the-header-user-navi__list__text" }, "ポイント確認", -1))
                ], 8, _hoisted_6)), [
                  [_directive_touch, void 0, "tap"]
                ])
              ]),
              (_ctx.thanksFunctionEnabled && !_ctx.isGroupBudget)
                ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                    _withDirectives((_openBlock(), _createElementBlock("a", {
                      href: _ctx.urls.thanksPoint,
                      class: "p-the-header-user-navi__list__link c-common-rounded-shadow__label"
                    }, [
                      _createElementVNode("i", _hoisted_10, [
                        _createVNode(_component_IconBase, {
                          width: 24,
                          height: 24,
                          "view-box": "0 0 24 24",
                          "icon-color": "#3c3c3c"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_IconThanksMessage)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", _hoisted_11, [
                          (_ctx.thanksPointUnreadCount > 0)
                            ? (_openBlock(), _createBlock(_component_TextLabelNewArrivalCount, {
                                key: 0,
                                count: _ctx.thanksPointUnread
                              }, null, 8, ["count"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.thanksPointName) + "メッセージ", 1)
                    ], 8, _hoisted_9)), [
                      [_directive_touch, void 0, "tap"]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_13, [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: _ctx.urls.whatsNew,
                  class: "p-the-header-user-navi__list__link c-common-rounded-shadow__label"
                }, [
                  _createElementVNode("i", _hoisted_15, [
                    _createVNode(_component_IconBase, {
                      width: 24,
                      height: 24,
                      "view-box": "0 0 24 24",
                      "icon-color": "#3c3c3c"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconNotification)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_16, [
                      (_ctx.whatsNewUnreadCount > 0 && !_ctx.isGroupBudget)
                        ? (_openBlock(), _createBlock(_component_TextLabelNewArrivalCount, {
                            key: 0,
                            count: _ctx.whatsNewUnread
                          }, null, 8, ["count"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "p-the-header-user-navi__list__text" }, "お知らせ", -1))
                ], 8, _hoisted_14)), [
                  [_directive_touch, void 0, "tap"]
                ])
              ]),
              _createElementVNode("li", _hoisted_17, [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: _ctx.urls.orders,
                  class: "p-the-header-user-navi__list__link c-common-rounded-shadow__label"
                }, [
                  _createElementVNode("i", _hoisted_19, [
                    _createVNode(_component_IconBase, {
                      width: 24,
                      height: 24,
                      "view-box": "0 0 24 24",
                      "icon-color": "#3c3c3c"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconOrderHistory)
                      ]),
                      _: 1
                    })
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "p-the-header-user-navi__list__text" }, "申込履歴", -1))
                ], 8, _hoisted_18)), [
                  [_directive_touch, void 0, "tap"]
                ])
              ]),
              _createElementVNode("li", _hoisted_20, [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: _ctx.urls.visit,
                  class: "p-the-header-user-navi__list__link c-common-rounded-shadow__label"
                }, [
                  _createElementVNode("i", _hoisted_22, [
                    _createVNode(_component_IconBase, {
                      width: 24,
                      height: 24,
                      "view-box": "0 0 24 24",
                      "icon-color": "#3c3c3c"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconHistoryLog)
                      ]),
                      _: 1
                    })
                  ]),
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "p-the-header-user-navi__list__text" }, "閲覧履歴", -1))
                ], 8, _hoisted_21)), [
                  [_directive_touch, void 0, "tap"]
                ])
              ]),
              _createElementVNode("li", _hoisted_23, [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: _ctx.urls.favorites,
                  class: "p-the-header-user-navi__list__link c-common-rounded-shadow__label"
                }, [
                  _createElementVNode("i", _hoisted_25, [
                    _createVNode(_component_IconBase, {
                      width: 24,
                      height: 24,
                      "view-box": "0 0 24 24",
                      "icon-color": "#3c3c3c"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconHeart)
                      ]),
                      _: 1
                    })
                  ]),
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "p-the-header-user-navi__list__text" }, "お気に入り", -1))
                ], 8, _hoisted_24)), [
                  [_directive_touch, void 0, "tap"]
                ])
              ]),
              (!_ctx.showMailSettings && !_ctx.isGroupBudget)
                ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                    _withDirectives((_openBlock(), _createElementBlock("a", {
                      href: _ctx.urls.mailSettings,
                      class: "p-the-header-user-navi__list__link c-common-rounded-shadow__label"
                    }, [
                      _createElementVNode("i", _hoisted_28, [
                        _createVNode(_component_IconBase, {
                          width: 24,
                          height: 24,
                          "view-box": "0 0 24 24",
                          "icon-color": "transparent"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_IconMail)
                          ]),
                          _: 1
                        })
                      ]),
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "p-the-header-user-navi__list__text" }, "メール受信設定", -1))
                    ], 8, _hoisted_27)), [
                      [_directive_touch, void 0, "tap"]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_29, [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: _ctx.urls.faq,
                  class: "p-the-header-user-navi__list__link c-common-rounded-shadow__label"
                }, [
                  _createElementVNode("i", _hoisted_31, [
                    _createVNode(_component_IconBase, {
                      width: 24,
                      height: 24,
                      "view-box": "0 0 24 24",
                      "icon-color": "#3c3c3c"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconFaqBalloon)
                      ]),
                      _: 1
                    })
                  ]),
                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "p-the-header-user-navi__list__text" }, "FAQ", -1))
                ], 8, _hoisted_30)), [
                  [_directive_touch, void 0, "tap"]
                ])
              ]),
              _createElementVNode("li", _hoisted_32, [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: _ctx.urls.qa,
                  class: "p-the-header-user-navi__list__link c-common-rounded-shadow__label"
                }, [
                  _createElementVNode("i", _hoisted_34, [
                    _createVNode(_component_IconBase, {
                      width: 24,
                      height: 24,
                      "view-box": "0 0 24 24",
                      "icon-color": "transparent"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconMail)
                      ]),
                      _: 1
                    })
                  ]),
                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "p-the-header-user-navi__list__text" }, "お問い合わせ", -1))
                ], 8, _hoisted_33)), [
                  [_directive_touch, void 0, "tap"]
                ])
              ]),
              _createElementVNode("li", _hoisted_35, [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: "javascript:void(0);",
                  class: "p-the-header-user-navi__list__link c-common-rounded-shadow__label",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitLogout && _ctx.emitLogout(...args)), ["prevent"]))
                }, [
                  _createElementVNode("i", _hoisted_36, [
                    _createVNode(_component_IconBase, {
                      width: 24,
                      height: 24,
                      "view-box": "0 0 24 24",
                      "icon-color": "transparent"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconLogout, { "icon-color": '#3c3c3c' })
                      ]),
                      _: 1
                    })
                  ]),
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "p-the-header-user-navi__list__text" }, "ログアウト", -1))
                ])), [
                  [_directive_touch, void 0, "tap"]
                ])
              ])
            ], 512), [
              [_vShow, _ctx.profileNavi.shown]
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}